module.exports = __webpack_public_path__ + "img/5860d10.jpg";